export const SET_ACCOUNT_VALUE ="SET_ACCOUNT_VALUE";
export const SET_ACCOUNT_REQUEST="SET_ACCOUNT_REQUEST";

export const FETCH_SIGNUP_REQUEST = "FETCH_SIGNUP_REQUEST";
export const FETCH_TODO_SUCCESS = "FETCH_TODO_SUCCESS";
export const FETCH_TODO_FAILURE = "FETCH_TODO_FAILURE";

export const FETCH_LOGIN_REQUEST = "FETCH_LOGIN_REQUEST";
